export const formatUsername = (username) => {
  const parts = username.split('#');
  
  if (parts.length === 2) {
    return (
      <>
        <span className="username-main">{parts[0]}</span>
        <span className="username-suffix">#{parts[1]}</span>
      </>
    );
  }
  
  return <span className="username-main">{username}</span>;
};

export const formatTime = (timestamp) => {
  if (!timestamp) return '—';

  let iso = String(timestamp).replace(/(\.\d{3})\d+$/, '$1');
  if (!/Z|[+-]\d{2}:\d{2}$/.test(iso)) {
    iso += 'Z';
  }

  const date = new Date(iso);
  
  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  return new Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  }).format(date);
};
